export default __webpack_public_path__ + "79867b7.png";